import axios from "axios";

export const StopDisplayApi = axios.create({
	//	baseURL: process.env.REACT_APP_STOPDISPLAY_URL,
	baseURL: "https://prod.api.pgc-nh.pixida.com",
});
